import React, { useState } from "react";
import { Card, Col, Row, Button, Select, Typography, Space, Radio } from "antd";
import { DownOutlined } from "@ant-design/icons";
import ReactECharts from "echarts-for-react";
import EnergyDashboard from "./EnergyDashboard";

const { Title, Text } = Typography;

const dataCards = [
  { title: "Daily Peak Demand", value: "132", unit: "kVA" },
  { title: "MTD Peak Demand", value: "18", unit: "kVA" },
  { title: "Live Demand", value: "12", unit: "kVA" },
  { title: "Real Power", value: "32", unit: "kW" },
  { title: "Reactive Power", value: "142", unit: "kVAr" },
  { title: "Power Factor", value: "62", unit: "" },
  { title: "Voltage", value: "72", unit: "V" },
  { title: "Current", value: "152", unit: "A" },
  { title: "V THD", value: "92", unit: "%" },
  { title: "I THD", value: "22", unit: "%" },
];

const chartOptions = {
  tooltip: {
    trigger: "axis",
  },
  legend: {
    data: ["Contracted Demand", "Peak Demand", "Base Demand"],
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: ["00:00", "00:15", "00:45", "01:15", "01:45", "02:00"],
  },
  yAxis: {
    type: "value",
    name: "Demand in kVA",
  },
  series: [
    {
      name: "Contracted Demand",
      type: "line",
      data: [100, 110, 105, 108, 107, 111],
      smooth: true,
    },
    {
      name: "Peak Demand",
      type: "line",
      data: [700, 800, 760, 750, 820, 880],
      smooth: true,
    },
    {
      name: "Base Demand",
      type: "line",
      data: [500, 520, 510, 530, 560, 590],
      smooth: true,
    },
  ],
};
const { Option } = Select;

const Dashboard = () => {
    const [activeTab, setActiveTab] = useState("1");
    console.log(activeTab)

  const handleChange = (value) => {
    console.log("Selected value:", value);
  };
  return (
    <div style={{ padding: 24 }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Title level={3}>Dashboard</Title>
        {
          activeTab === "1" &&(
            <Select
      defaultValue="option1"
      style={{ width: 200 }}
      onChange={handleChange}
      placeholder="Filter By Sensor"
    >
      <Option value="option1">Option 1</Option>
      <Option value="option2">Option 2</Option>
      <Option value="option3">Option 3</Option>
    </Select>
          )
        }
      </Row>

      <Space style={{ marginBottom: 16 }}>
         <Radio.Group
        value={activeTab}
        onChange={(e) => {setActiveTab(e.target.value)}}
        style={{ marginBottom: 16 }}
      >
        <Radio.Button value="1">Power Demand</Radio.Button>
        <Radio.Button value="2">Energy</Radio.Button>
      </Radio.Group>
      </Space>
      {
        activeTab === "1" &&
          <>
            <Title level={4}>Power Demand</Title>
      <Card className="bg-blue-50">
      <Row gutter={[16, 16]}>
        {dataCards.map((card, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={6} xl={4}>
            <Card size="small" hoverable>
              <Title level={5}>{card.title}</Title>
              <Text strong style={{ fontSize: 20 }}>
                {card.value}
                <span style={{ fontSize: 14 }}>{card.unit}</span>
              </Text>
              <br />
              <Text type="danger">
                ↓ 40% <span style={{ color: "gray" }}>vs Target</span>
              </Text>
            </Card>
          </Col>
        ))}
      </Row>

      </Card>

      <Card style={{ marginTop: 24 }}>
        <Title level={5}>Plant Load Curve</Title>
        <ReactECharts option={chartOptions} style={{ height: 300 }} />
      </Card>
          </>
}
{activeTab==="2"&&
    <>
    <EnergyDashboard />
    </>
}
    
    </div>
  );
};

export default Dashboard;
